<template>

  <transition appear>

    <div class="all_wrapper">

      <div class="home wrapper" id="home">


        <main class="home__container container">
          <div class="mobile-logo">
            <img src="../assets/img/vendor/x4_mobile.svg" alt="mobile-logo">
          </div>
          <div class="home__text-wrap">
            <h1 class="home__title title" v-html="title">
            </h1>

           <div class="home__html" v-html="desc">
           </div>

          </div>



        </main>
      </div>

      <!--Works-->
      <div class="wrapper" id="work">


        <div class="works__container container">
          <ul class="works__list">


            <li class="works__list-item" v-for="work in works">
<!--              <p>{{work.name}}</p>-->
              <span class="works__list-item_fill"></span>
              <h3 class="works__list-item_title"><a href="" :data-id="work.slug">{{work.name}}</a>
                <span class="works__list-item_img">
                  <span class="works__list-item_img-inner">
                      <img :src="work.main_image" alt="work_image">
                  </span>
                </span>
              </h3>
            </li>


          </ul>
        </div>
      </div>


      <!--About-->
      <div class="wrapper">
        <div class="about__container container" id="about">
          <div class="about__row">
            <div class="about__col">
              <h5 class="about__title title">{{about_title}}</h5>
              <p class="about__text text">{{about_desc}}</p>
            </div>

            <div class="about__col" id="people-col">

              <ul class="about__list">
                <li v-for="item in about_list">{{item | trim}}</li>
              </ul>
<!--              <div class="about__peoples">-->
<!--                <a :href="man.link" rel="nofollow" class="about__peoples-item" v-for="man in crew">-->
<!--                  <div class="about__peoples-item_img">-->
<!--                    <img :src="man.avatar" alt="crew image">-->
<!--                  </div>-->
<!--                  <h4 class="about__peoples-item_work">{{man.name}} <br> <span class="about__peoples-item_name"> {{man.position}}</span></h4>-->
<!--                </a>-->

<!--              </div>-->

            </div>
          </div>
          <div class="about__row">
            <div class="about__col">
              <h5 class="about__title title">{{we_do_title}}</h5>
              <p class="about__text text" >{{we_do_desc | trim}}
                <br><br>

              </p>
            </div>
            <div class="about__col">
              <p class="about__title title hide">x4</p>

              <ul class="about__list about__list-bottom">
                <li v-for="item in we_do_list">{{item | trim}}</li>
              </ul>
            </div>
          </div>

        </div>


      </div>


      <!--Contacts-->
      <div class="contacts__wrapper wrapper" id="contacts">

        <div class="contacts__container about__container container">
          <div class="about__row">
            <div class="about__col">
              <h5 class="contacts__title title"></h5>
              <p class="contacts__text about__text text">
                {{contacts | trim}}
              </p>
            </div>

            <div class="about__col">
              <form action="" class="contacts__form">
                <div class="contacts__form-input">
                  <input type="text" name="name" placeholder="Name">
                </div>
                <div class="contacts__form-input">
                  <input type="text" name="company" placeholder="Company">
                </div>
                <div class="contacts__form-input">
                  <input type="text" name="email" placeholder="E-mail">
                </div>

                <textarea></textarea>
                <button class="contacts__form-btn white_line" type="submit">Send</button>
              </form>

              <aside class="contacts__contacts">
                <p>{{ adress }}</p>
                <a class="contacts__contacts-phone"></a> <br>
                <a class="white_line" href="mailto:info@x4.com"></a>
              </aside>

            </div>
          </div>
        </div>
      </div>




    </div>

  </transition>

</template>
<script>
  const ScrollMagic = require('ScrollMagic');
  require('jquery.nicescroll');
  require('animation.gsap');
  require('debug.addIndicators');
  import '../assets/js/vendor/type'
  import domain, {main_domain} from '../assets/js/config.js'
  var qs = require('qs');


  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = jQuery.trim(cookies[i]);
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  function buildRGB( input1, input2, input3 ){

    var RGB = 'rgba(' + input1 + ', ' + input2 + ', ' + input3 + ', .6)';
    return RGB;
  }

  function buildLinearGradient( direction, RGB1, RGB2 ){
    // console.log(RGB1, RGB2)
    var gradient = 'linear-gradient(' + direction + ', ' + RGB1 + ', ' + RGB2 + ')';
    return gradient;
  }
  var
    windowWidth = window.innerWidth,
    windowHeight = window.innerHeight,

    /* Any whole number between 0 and 255. Greater values have more dramatic effect */
    rgbRange = 100,

    /* Set the value of one unit so we can limit the gradient to rgbRange later */
    xUnit = windowWidth/rgbRange,
    yUnit = windowHeight/rgbRange,

    /* Set where to start the range from, 0 being black etc. Must be no more than 255 minus rgbRange */
    xStart = 255,
    yStart = 255;



  import ScrollToPlugin from 'gsap/src/minified/plugins/ScrollToPlugin.min.js'

  export default {
  name: 'Home',
  data () {
    return {
      works: {},
      title: '',
      desc: '',
      about_title: '',
      about_desc: '',
      about_list: '',
      we_do_title: '',
      we_do_desc: '',
      contacts: '',
      we_do_list: '',
      adress: '',
      crew: '',
      controller: '',
      canMoveText: true
    }
  },
  filters: {
    trim: function (string) {
      return string.trim()
    }
  },
    // Страница готова к рендерегу
    // =======================================================================================
  created: function () {


    var self = this;

    axios.get(domain)
      .then(function (response) {
        // console.log(JSON.stringify(response.data))
        // Берем данные с сервера, заполняем переменные
        // ----------------------------------------------------------------------------------
        self.title = response.data.static.data.titile;
        self.desc = response.data.static.data.main_desc;
        self.about_title = response.data.static.data.about_title;
        self.about_desc = response.data.static.data.about_desc;
        self.we_do_title = response.data.static.data.we_do_title;
        self.we_do_desc = response.data.static.data.we_do_desc;
        self.contacts = response.data.static.data.contacts;
        self.we_do_list = response.data.static.data.we_do_list.split('|');
        self.adress = response.data.static.data.adress;
        self.email = response.data.static.data.email;
        self.crew = response.data.static.data.crew;
        // ----------------------------------------------------------------------------------

        // Проставляем атрибуты href для ссылок
        // ----------------------------------------------------------------------------------
        var phone = document.querySelector('.contacts__contacts-phone');
          phone.innerHTML = response.data.static.data.phone;
          phone.setAttribute('href', 'tel:' + response.data.static.data.phone);

        var email = document.querySelector('.contacts__contacts .white_line');
        email.innerHTML = response.data.static.data.email;
        email.setAttribute('href', 'mailto:' + response.data.static.data.email);


        document.querySelector('.contacts__title').innerText = response.data.static.data.contacts_title;
        // ----------------------------------------------------------------------------------

        // Данные о проектах, добавляем домен сервера где лежат картинки
        // ----------------------------------------------------------------------------------
        self.works = response.data.works;
        self.works.map((e)=>{
          e.main_image = domain +'/media/'+ e.main_image
        });
        self.crew.map((e)=>{
          e.avatar = domain +'/media/'+ e.avatar
        });
        // ----------------------------------------------------------------------------------

        // Создаем массив из строки поля, для вывода его в формате списка
        // ----------------------------------------------------------------------------------
        self.about_list = response.data.static.data.about_list.split('|');



        // SEO
        // ----------------------------------------------------------------------------------
        document.querySelector('meta[name="description"]').setAttribute("content", response.data.static.data.seo_description);
        document.querySelector('meta[name="keywords"]').setAttribute("content", response.data.static.data.seo_content);
        document.title = response.data.static.data.seo_title;
        // ----------------------------------------------------------------------------------

        // Open Graph
        // ----------------------------------------------------------------------------------
        document.querySelector('meta[property="og:title"]').setAttribute("content", response.data.static.data.og_title);
        document.querySelector('meta[property="og:description"]').setAttribute("content", response.data.static.data.og_desc);
        document.querySelector('meta[property="og:image"]').setAttribute("content", domain  + response.data.static.data.og_image);
        document.querySelector('meta[property="og:url"]').setAttribute("content", main_domain);
        // ----------------------------------------------------------------------------------


// Анимация градиента на главной
// ----------------------------------------------------------------------------------
        var $el = $('body');
        $el.removeClass('body-project');
        var x = 0;
        var is_iPad = navigator.userAgent.match(/iPad/i) != null;
        var body = document.querySelector('.bg')
        var window_width = $(window).width();
        var mobile = window_width <= 561;
        if (mobile) {

          $('.home__scroll').prependTo('body')
        }
        if (!is_iPad) {

          $el.on('mousemove', function (e) {
            if ($('.app--home').length >= 1 && self.canMoveText && window_width > 561) {
              var xCoords = e.clientX,
                yCoords = e.clientY,
                x, y, z, RGB1, RGB2, gradient;

              // Limit xCoords to rgbRange
              for( x = 0; x <= rgbRange; x += 1 ){
                if( xCoords >= xUnit * x && xCoords <= xUnit * (x + 1)) {
                  x += xStart;
                  xCoords = x;
                }
              }

              // Limit yCoords to rgbRange
              for( y = 0; y <= rgbRange; y += 1 ){
                if( yCoords >= yUnit * y && yCoords <= yUnit * (y + 1)) {
                  y += yStart;
                  yCoords = y;
                }
              }

              // Build RGB values and gradient
              z = xCoords - yCoords,
                RGB1 = buildRGB( z + 70, yCoords-50, xCoords + 100 ),
                // RGB1 = buildRGB( z, 255, 100 ),
                RGB2 = buildRGB( xCoords + 100, z + 180, yCoords  - 200 ),
                gradient = buildLinearGradient( 'to right', RGB1, RGB2 );

              // Set background to gradient
              body.style.background = gradient;
            }
          });

        }
// ----------------------------------------------------------------------------------


// Добавляем setTm для адекватной отработки скрипта (поиск нужных элементов после рендеринга)
// ----------------------------------------------------------------------------------
        setTimeout(function () {
          // Делаем рандом позиций тайтлов проектов
          // --------------------------------------------------------------------
          document.querySelectorAll('.works__list-item_fill').forEach(function (item) {
            var radndom_num;
            var b = item.style.width + 'px';
            radndom_num = Math.floor(Math.random() * ($(window).width() >= 768 ? 100 : 50));
            item.style.width =  'calc( ' + radndom_num  + '% )'
          });

          if ($(window).width() >= 768 && !is_iPad) {

            var titles_even =  $('.works__list-item_title:even'),
              titles_odd = $('.works__list-item_title:odd'),
              all_titles = $('.works__list-item_title');

            var time
            var reset = function () {
              clearTimeout(time)
              time = setTimeout(()=>{all_titles.css('willChange', 'auto'); }, 1000)
            }

            // Анимация текста
            // ++++++++++++++++++++++++
            $('#work').on('mousemove', function (e) {
              if (self.canMoveText) {

                if (all_titles.css('willChange') === 'auto') {
                  all_titles.css('willChange', 'transform')
                  reset()
                }
                setTimeout(()=>{
                  all_titles.css('transition', '0s')
                }, 200)
                var x = e.pageX;

                titles_even.css({
                  'transform': 'translateX(' + -x*0.05 + 'px)'
                });

                titles_odd.css({
                  'transform': 'translateX(' + x*0.05 + 'px)'
                });
              }
            })
            // +++++++++++++++++++++++++
          }

          // --------------------------------------------------------------------


          // Добавляем обработчик клика для перехода анимированного на страницу проекта
          // --------------------------------------------------------------------
          var body = $( "body" );
          $('.works__list-item_title a').click(function(e) {

            body.addClass('anim'); // в момент перехода добавляем класс для анимации глоб элементов

            e.preventDefault();
            e.stopPropagation();

            // Принудительно останавливаем скролл
            // ++++++++++++++++++++++++++++++++++++++++
            $(window).bind( "mousewheel", function(e) {
              e.preventDefault();
              e.stopPropagation();
            });
            // ++++++++++++++++++++++++++++++++++++++++

            var item = $(this).parent().parent(); // Тайтл "кликнутого" проекта
            var id = $(this).data('id'); // Его айди
            var img = item.find('.works__list-item_img'); // Его картинка

            item.addClass('anim__stophover'); // Добавляем класс для анимации
            item.find('.works__list-item_title').addClass('works__list-item_title--animation');  // Добавляем класс для анимации

            // Подключаем gsap
            // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            var tl = new TimelineMax();
            var time = .2;
            tl.to(img, time, {scale: 0, opacity: 0,  },)
              .to('.works__list-item_title:not(.works__list-item_title--animation)', .4, {opacity: 0}, 0)
              .to('.works__list-item_title--animation ', .4, {opacity: 0, onComplete: go_route}, time + .1)
            // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

            // Функция перехода на страницу проекта
            // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            function go_route() {
              // setTimeout(function () {
              self.controller.destroy();
              $(window).unbind( "mousewheel");
              self.$router.push({name: 'Project', params: { id: id }});
              document.querySelector('.home__lines').style.opacity = 1;
              body.removeClass('anim')

              // }, 100)
            }
            // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          });

          if (!is_iPad) {
            // Эффект паралакса на фотках проектов
            // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            $('.works__list-item_title').mousemove(function (e) {
              const boundingClientRect = this.getBoundingClientRect()
              const x = e.clientX - boundingClientRect.left;
              const y = e.clientY - boundingClientRect.top;

              const xc = boundingClientRect.width/2;
              const yc = boundingClientRect.height/2;

              const dx = x - xc;
              const dy = y - yc;
              TweenMax.to($(this).find('.works__list-item_img-inner'), 1,   { x: dx/ 5 })
              TweenMax.to($(this).find('img'), 1,   { y: `${dx/ 20}`, scale: 1.2, force3D:false })
            });

          }
          // Ссылки для работы
          // -----------------------------
          var works = document.querySelectorAll('.works__list-item_title a');
          works.forEach((item)=>{
            item.setAttribute('href', '/' + item.getAttribute('data-id') + '/');
          });
          // -----------------------------


          // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


          // mobile search
          // ----------------------------
          var ch = true
          if (mobile && ch) {
            ch = false
            // функция чека событий во вьюпорте
            var mask = $('.mobile-mask');

            function isView(elem)
            {
              var docViewTop = $(window).scrollTop();
              var docViewBottom = docViewTop + $('.fix').height();
              var elemTop = $(elem).offset().top;
              var elemBottom = elemTop + $(elem).height();


              return (elemTop - 200<= docViewTop && docViewBottom  < elemBottom  + 320);
              // return true
            }


            // ловим скролл и меняем год на актуальный во вьюпорте
            var titles = $('.works__list-item');

            var active_field = false

            $(window).scroll(function (e) {
              if (self.$route.name === 'Home') {
                if (!isView($('#work'))) {
                  mask.find('p').text('')
                  $('.works__list-item').removeClass('scale')
                  $('.home__scroll').css('opacity', 1)
                }
                else {
                  $('.home__scroll').css('opacity', 0)

                }

                titles.each(function () {

                  var elemTop = $(this).offset().top;
                  var sum = (mask.offset().top) - elemTop;
                  var scale = sum > 0 && sum < 80;
                  var self = $(this)
                  var title = $(this);

                  if (title.find('p').text() === 'PMI SHOW') {
                  }
                  // console.log(mask.offset().top + 20,  elemTop)
                  if ( scale) {
                    if (!title.hasClass('scale')) {

                      // console.log(title.text(), title.hasClass('scale'))
                      // $('.works__list-item').removeClass('scale')
                      // title.addClass('scale')
                      // typemobile.deleteAll().typeString('2').start()

                      active_field = self
                      // TweenMax.to(mask, .1, {opacity: 0, onComplete:()=>{
                      //     mask.find('p').text(self.text())
                      //     TweenMax.to(mask, .1, {opacity: 1, onComplete:()=>{
                      //       }})
                      // }})


                    }

                  }

                });
              }


            });
          }
          // --------------------------
        })


      })
      .catch(function (error) {
        console.log(error);
      });
  },
    // =====================================================================================


  // Действия после рендерига и получения данных
  // =====================================================================================
    mounted: function () {
      this.controller = new ScrollMagic.Controller();
      var that = this;
      var type = document.querySelector('.top_title');

      if (navigator.appVersion.indexOf("Win")!=-1) {
        $('.header__list-item').css({
          'backface-visibility': 'hidden',
          'transform-origin': '51% 65%'
        })
      };

      // Объявлеям скрипт по тайпинку подзаголовков
      // +++++++++++++++++++++++++++++++++++++++++++
      var typewriter = new Typewriter(type, {
        animateCursor: false,
        cursor: '_',
        typingSpeed: 40,
        deleteSpeed: 40
      });
      // +++++++++++++++++++++++++++++++++++++++++++

      // Функция для написания подзаголовка
      // +++++++++++++++++++++++++++++++++++++++++++++++++
      var typeTime;
      var type = function (x) {
        clearTimeout(typeTime);
        typeTime = setTimeout(function () {
          typewriter.deleteAll().typeString(x).start()
        },400)
      };
      // +++++++++++++++++++++++++++++++++++++++++++++++++



      // Если в хеше нет #work пишем web & design
      // иначе скролим до блока с проектами
      // +++++++++++++++++++++++++++++++++++++++++++
      if (that.$route.hash !== '#work') {
        type('web & design');
      }
      else {
        setTimeout(()=>{
          $('html, body').animate({
            scrollTop: $("#work").offset().top
          }, 300);
        },300)
      }
      // +++++++++++++++++++++++++++++++++++++++++++


      // Обработчик клика по элементам меню (фалсим глобальную переменнку can_scroll)
      // +++++++++++++++++++++++++++++++++++++++++++
      $('.header__list-item a').click(function () {
        window.can_scroll = false;

        setTimeout(function () {
          window.can_scroll = true
        }, 1000)
      });
      // +++++++++++++++++++++++++++++++++++++++++++


      // Через 300 мс показываем градиент
      // +++++++++++++++++++++++++++++++++++++++++++
      // setTimeout(function () {
      //   $('.bg').css('opacity', .6);
      // }, 300);
      // +++++++++++++++++++++++++++++++++++++++++++


      // Анимация svg элемента на первой странице
      // -------------------------------------------------------------------------------------------
      // -------------------------------------------------------------------------------------------
      var homeScroll = new TimelineMax({onComplete: function () {
          this.restart()
        }});
      var svg_elem = $('.home__scroll');
      var window_width = $(window).width();

      var mobile = window_width <= 561;

      if (!mobile) {
        svg_elem.hover(function () {
            homeScroll.pause();
            TweenMax.to("#scroll",1,  {y: -25, scaleY: 1.6 })
          },
          function () {
            TweenMax.to("#scroll",1,  {y: 30,scaleY: 0, ease: Bounce.easeOut, onComplete: function () {
                homeScroll.restart()
              }})
          });
      }
      svg_elem.click(function () {
        TweenMax.to(window, 1, {scrollTo:'#work'});
      });

      homeScroll.set("#scroll", {y: 30,scaleY: 0});
      homeScroll
        .to("#scroll", 1, { y: -25, scaleY: 1.6 })
        .to("#scroll", 1, {y: 30,scaleY: 0, ease: Bounce.easeOut}, '+=0')
        .to("#scroll", 1, { y: -25, scaleY: 1.6 }, '+=.4')
        .to("#scroll", 1, {y: 30,scaleY: 0, ease: Bounce.easeOut}, '+=0')
        .to("#scroll", .4, {y: 30,scaleY: 0, }, '+=0');
      // -------------------------------------------------------------------------------------------
      // -------------------------------------------------------------------------------------------



      // Включаем анимацию на скролле только если мы на главной странице
      // ----------------------------------------------------------------------------
      if (that.$route.name === 'Home') {

        // Анимация исчезновения svg. Начало - Работы
        // ++++++++++++++++++++++++++++++++++++++++++
        var scene = new ScrollMagic.Scene({
          triggerElement: '#work',
        })
          .setTween(".home__scroll", 1 ,{y: 100})
          .addTo(this.controller);
        // ++++++++++++++++++++++++++++++++++++++++++


        // Анимация исчезновения линий и лого. Начало - Топ страницы
        // ++++++++++++++++++++++++++++++++++++++++++
        var scene2 = new ScrollMagic.Scene({
          triggerElement: 0,
          duration: '100%',
        })
          .setTween('.home__lines', {opacity: 0})
          .addTo(this.controller);
        // ++++++++++++++++++++++++++++++++++++++++++


        // видимость элемента при скролле
        // +++++++++++++++++++++++++++++++++++++++++++++++++++
        function isScrolledIntoView(elem)
        {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();

          var elemTop = $(elem).offset().top;
          var elemBottom = elemTop + $(elem).height();

          // console.log(docViewBottom - 230,elemTop);

          return (elemTop <= docViewBottom - 230);
        }
        // +++++++++++++++++++++++++++++++++++++++++++++++++++






        var is_iPad = navigator.userAgent.match(/iPad/i) != null;

        // Анимация появления тайтлов работы и написание подзаголовков. Начало - Топ страницы
        // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        if (!is_iPad && !mobile) {
          var scene3 = new ScrollMagic.Scene({
            triggerElement: 0,
            offset: '150%',
            duration: 1000,
          })
          // Если скрол вниз
            .on("start end", function (e) {
              if (e.type === 'start' && e.scrollDirection === 'FORWARD') {
                setTimeout(() => {type('work');}, 100);
                // показываем тайтлы

                TweenMax.staggerFromTo('.works__list-item', .5, {x:'5%', opacity: 0}, {x: '0%', opacity: 1 , onComplete: ()=>{
                    $('.works__list-item').css('transform','none');
                  }}, .1)
              }
              // Если скрол вверх
              else if (e.type === 'start' && e.scrollDirection === 'REVERSE'){
                setTimeout(() => {type('web & design');}, 100);
                // прячем тайтлы
                TweenMax.set('.works__list-item', {x: '5%', opacity: 0})

              }
            })
            .addTo(this.controller);
          // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

        }
        if (!mobile) {

          // Функция поиска направления скролла
          // Нужна для скролла к блоку работ
          // Отрабатывает на поле первого экрана ТОП
          // ------------------------------------------------------------------------------------------------

          // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          function onWheel(e) {
            var delta = e.deltaY || e.detail || e.wheelDelta;
            var scroll_direction = delta > 0 ? 'bottom' : 'top';

            if (scroll_direction === 'bottom') {
              that.canMoveText = false

              $(window).bind( "mousewheel", function(e) {
                e.preventDefault();
                e.stopPropagation();
              });

              TweenMax.to(window, 1, {scrollTo: '#work', onComplete: function () {
                  $(window).unbind( "mousewheel");
                  $('.works__list-item_title').css('transition', '.2s')
                  that.canMoveText = true
                }});
            }
          }
          // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


          // ловим скрол и меням поле
          var elem = document.querySelector('#home');
          if (elem.addEventListener) {
            if ('onwheel' in document) {
              // IE9+, FF17+, Ch31+
              elem.addEventListener("wheel", onWheel);
            } else if ('onmousewheel' in document) {
              // устаревший вариант события
              elem.addEventListener("mousewheel", onWheel);
            } else {
              // Firefox < 17
              elem.addEventListener("MozMousePixelScroll", onWheel);
            }
          } else { // IE8-
            elem.attachEvent("onmousewheel", onWheel);
          }
          // ------------------------------------------------------------------------------------------------





          // Изменение подзаголовкой на скроле
          // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          new ScrollMagic.Scene({
            triggerElement: '#about',
            duration: $('#about').height(),
          })

            .on("start end", function (e) {
              if (e.type === 'start' && e.scrollDirection === 'FORWARD') {
                // console.log(isScrolledIntoView($('#about')))
                if (isScrolledIntoView($('#about'))) {
                  setTimeout(() => {type('about us');}, 0);
                }
              }
              else if (e.type === 'start' && e.scrollDirection === 'REVERSE'){
                setTimeout(() => {type('work');}, 100);
              }
            })
            .addTo(this.controller);

          new ScrollMagic.Scene({
            triggerElement: '#contacts',
            duration: $('#contacts').height(),
          })

            .on("start end", function (e) {
              if (e.type === 'start' && e.scrollDirection === 'FORWARD') {
                setTimeout(() => {type('contact us');}, 100);
              }
              else if (e.type === 'start' && e.scrollDirection === 'REVERSE'){
                setTimeout(() => {type('about us');}, 100);
              }
            })
            .addTo(this.controller);
          // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

        }

        // Сролл наверх по клику на лого
        // +++++++++++++++++++++++++++++++++++++++++++
        $('.header__list-item_logo').click(function () {
          TweenMax.to(window, 1, {scrollTo: 0});
        });
        // +++++++++++++++++++++++++++++++++++++++++++

      }
      // ------------------------------------------------------------------------------------------------

      axios.get(domain + '/gt').then((data)=>{
        setCookie('csrftoken',data.data.token, 1 );
      });

      axios.defaults.xsrfCookieName = "csrftoken";
      axios.defaults.xsrfHeaderName = "X-CSRFToken";

      function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      var btn = $('.contacts__form-btn')

      $('.contacts__form').submit(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!window.isSend) {
          var csrftoken = getCookie('csrftoken');



          var data = {
            'name': $('input[name=name]').val(),
            'company': $('input[name=company]').val(),
            'email': $('input[name=email]').val(),
            'message': $('textarea').val()
          };
          for (var i = 1; i <= Object.keys(data).length; i++) {
            if (data[Object.keys(data)[i-1]] === '') {
              alert('Please, fill all fields');
              return false
            }
          }
          if (!validateEmail(data.email)) {
            alert('Wrong email')
            return false
          }

          btn.addClass('load')



          axios({
            method: 'post',
            url: domain + '/mail',
            // data: qs.stringify(data),

            data:
            data,

            headers: {
              'x-csrftoken': csrftoken
            },
            // withCredentials: true,
          })
            .then(responce=>{
              btn.text('Thank you')
              btn.css('pointer-events', 'none')
              window.isSend = true
              $('input[name=name]').val(''),
              $('input[name=company]').val(''),
              $('input[name=email]').val(''),
              $('textarea').val('')
              btn.removeClass('load')
              btn.addClass('load--end');

            })
            .catch(error=>{
              alert('Server error, please wait')
              btn.removeClass('load')
            });

        }
        else {
          btn.text('Thank you');
          btn.addClass('load--end');
          btn.css('pointer-events', 'none')

        }

      })

    }
    // ====================================================================================================

}
</script>




// WEBPACK FOOTER //
// src/components/Home.vue